import {useHistoryListener} from 'core/next/hooks/useHistotyListener';
import {TBeforePopStateCallback} from 'core/types';
import {useRouter} from 'next/router';
import {useCallback} from 'react';

export const useHistoryWithGSSP = () => {
    const router = useRouter();

    const handleHistoryChange = useCallback<TBeforePopStateCallback>(
        ({url, as, options}) => {
            if (options.shallow) {
                router.replace(url, as, {shallow: false});

                return false;
            }

            return true;
        },
        [router]
    );

    useHistoryListener(handleHistoryChange);
};
